import { CzechSuklRsAtcGroupResponse } from 'com.cogvio.pricemonitor.api';

type ProductVersion = CzechSuklRsAtcGroupResponse['products'][number]['productVersions'][number];

/**
 * Orders product versions for display: main LP first, identical LPs below.
 *
 * The API exposes no validity date on versions. Per business convention, the
 * currently valid LP has the higher SÚKL code; the secondary LP has a lower code
 * and is typically valid only briefly.
 *
 * @param {ProductVersion[]} versions the versions to sort.
 * @returns {ProductVersion[]} versions sorted with main LP first.
 */
export function sortProductVersionsMainFirst(versions: ProductVersion[]): ProductVersion[] {
	return [...versions].sort((a, b) => (b.suklCode ?? '').localeCompare(a.suklCode ?? '', undefined, { numeric: true }));
}
